import { useEffect } from 'react';
import { useCookieModalContext } from '@starlingbank/cookie-modal';

export const ABScriptLoader = () => {
  const cookieModalContext = useCookieModalContext();
  const hasAnalyticsConsent = cookieModalContext?.cookieObject?.analytics || false;

  // If the user accepts analytics cookies in the cookie modal, and the AB Tasty tag isn't already on the site, then add it
  useEffect(() => {
    if (hasAnalyticsConsent && typeof window.ABTasty === 'undefined') {
      window.writeABTastyTag();
    }
  }, [hasAnalyticsConsent]);
};
